"use client";
import React, { useEffect, useRef, useState } from "react";
import { Feed } from "./Feed/Feed";
import { handleImages } from "./utils/handleImages";
import { handleAttributes } from "./utils/handleAttributes";
import { InstagramOptionsType } from "@/types/ModuleOptionsType";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { useLenis } from "lenis/react";
import { AddProperty } from "@/components/PopUp/PopUp";
import { useAppContext } from "@/context/AppContext";
import { Modul_Instagram } from "@aleksundshantu/gp-types/acf-module";

import useWindowSize from "@/hooks/useWindowSize";
import useUpdateEffect from "@/hooks/useUpdateEffect";

export type InstaModuleType = Modul_Instagram;

interface InstaFeedProps {
  feed: string;
  options: InstagramOptionsType;
  followUrl?: string;
}

export const InstaFeed = ({ feed, options, followUrl }: InstaFeedProps) => {
  const { getLabel } = useGlobalContext();

  const baseContainerRef = useRef<HTMLDivElement>(null);
  const { width } = useWindowSize();
  const imgCount = width < 768 ? 4 : width < 1024 ? 3 : width < 1920 ? 4 : 5;
  // number of how many posts will be loaded on load more click.
  const loadCount = imgCount;
  // number of initial videos displayed in the feed. (e.g. 6)
  const initialCount = imgCount;

  const [loadMore, setLoadMore] = useState<boolean>(true);
  const [imageCount, setImageCount] = useState<number>(0);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [images, setImages] = useState<any[]>([]);

  const imageLoader = () => {
    const htmlDoc = new DOMParser().parseFromString(feed, "text/html");
    const base = htmlDoc.body.querySelector("#sb_instagram");

    if (base) {
      handleAttributes(base, baseContainerRef);
      base.removeAttribute("class");
      base.removeAttribute("style");
    }

    const images = base?.querySelector("#sbi_images");

    const imagesLength = images?.children.length;
    if (imagesLength && imageCount >= imagesLength - initialCount) {
      setLoadMore(false);
    } else {
      setLoadMore(true);
    }

    handleImages(images, initialCount, imageCount, loadCount, setImages);
  };

  useEffect(() => {
    setImages([]);
    setImageCount(0);
    imageLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialCount]);

  useUpdateEffect(() => {
    imageLoader();
  }, [imageCount]);

  const { instagramModal } = useAppContext();
  const lenis = useLenis();
  useEffect(() => {
    const htmlTag = document.documentElement;
    const scrollBarWidth = window.innerWidth - htmlTag.clientWidth;
    const tagsToAddmargin = document.getElementsByClassName(
      "scrollbar-width",
    ) as HTMLCollectionOf<HTMLElement>;
    if (instagramModal) {
      if (scrollBarWidth !== 0) {
        AddProperty(
          tagsToAddmargin,
          "width",
          `calc(100% - ${scrollBarWidth}px)`,
        );
        htmlTag.style.marginRight = `${scrollBarWidth}px`;
      }
      lenis?.stop();
    } else {
      AddProperty(tagsToAddmargin, "width", `100%`);
      htmlTag.style.marginRight = `unset`;
      lenis?.start();
    }
  }, [instagramModal, lenis]);

  return (
    <>
      <div className="feed-wrapper">
        <div ref={baseContainerRef}>
          {images.length > 0 ? (
            <Feed
              props={{
                images,
                loadMore,
                loadCount,
                loadMoreText: getLabel("load_more_label", "Load more"),
                setImageCount,
                followUrl,
                options,
                followText: getLabel(
                  "follow_on_instagram",
                  "Follow on Instagram",
                ),
              }}
            />
          ) : (
            <p>{getLabel("no_posts_instagram")}</p>
          )}
        </div>
      </div>
      {/* <AnimatePresence>
        {modal && (
          <motion.div
            variants={clip_circle_top_variant}
            initial={"initial"}
            animate={"animate"}
            exit={"exit"}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              zIndex: 9999,
              width: "100%",
              height: "100%",
            }}
            className={styles["insta-modal-wrapper"] + " scrollbar-width"}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setModal(null);
            }}
          >
            <Modal modal={modal} setModal={setModal} />
          </motion.div>
        )}
      </AnimatePresence> */}
    </>
  );
};
